import {
    MutableRefObject,
    useCallback,
} from 'react'

import {
    gridFilterModelSelector,
} from '@mui/x-data-grid-pro'
import {
    TableFilterParams,
} from 'app/types/common.types'

import {
    ExtendedGridApiPro,
    getFiltersFromFilterModel,
} from '../SkyBaseDataGrid'

type Props = {
    /** base request data that should be extended with filters from DataGrid */
    requestData: Record<string, any>
    /** ref to DataGrid API instance */
    gridApiRef: MutableRefObject<ExtendedGridApiPro>
}

/** This hook returns function that can be used to get exact filters,
 * which are applied to filter request when fetching data
 * (e.g. searchAll, includeFilters, filters etc).
 * It populates default request data with filters derived from DataGrid component.
 * @returns function that returns extended filter params used in data request
 * */
const useGetExtendedFilterParams = ({
    requestData,
    gridApiRef,
}: Readonly<Props>) => {
    return useCallback((): TableFilterParams => {
        if (!gridApiRef?.current) {
            return requestData
        }

        const filterModel = gridFilterModelSelector(gridApiRef)

        if (!filterModel) {
            return requestData
        }

        const {
            searchAll,
            includeFilters,
            ...otherFilterForBody
        } = getFiltersFromFilterModel(filterModel)

        return {
            ...requestData,
            includeFilters: {
                ...requestData?.includeFilters,
                ...includeFilters,
            },
            searchAll,
            ...otherFilterForBody,
        }
    }, [
        gridApiRef,
        requestData,
    ])
}

export default useGetExtendedFilterParams
